import { render, staticRenderFns } from "./detail-tab-participantes.vue?vue&type=template&id=0fc94688&"
import script from "./detail-tab-participantes.vue?vue&type=script&lang=js&"
export * from "./detail-tab-participantes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fc94688')) {
      api.createRecord('0fc94688', component.options)
    } else {
      api.reload('0fc94688', component.options)
    }
    module.hot.accept("./detail-tab-participantes.vue?vue&type=template&id=0fc94688&", function () {
      api.rerender('0fc94688', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/crm/components/detail-tab-participantes/detail-tab-participantes.vue"
export default component.exports